import React, { useRef, useState } from "react";
import styles from "./styles.module.scss";

const SIGNUP = "https://www.parceirospromo.com.br/signup/";

type Step = {
  n: string;
  icon: string;
  iconTitle?: string;
  title: string;
  desc: React.ReactNode;
};

const STEPS: Step[] = [
  {
    n: "01",
    icon: "/images-capa2/comoFunciona/step-cadastro.svg",
    iconTitle: "ícone cadastro",
    title: "Cadastre-se gratuitamente!",
    desc: (
      <>
        Primeiro{" "}
        <a href={SIGNUP} target="_blank" rel="noreferrer">
          você se cadastra
        </a>{" "}
        sem custos no nosso programa
      </>
    ),
  },
  {
    n: "02",
    icon: "/images-capa2/comoFunciona/suporte.svg",
    iconTitle: "ícone suporte",
    title: "Receba o suporte necessário",
    desc: "Depois, nossa equipe de especialistas entrará em contato para tirar todas as dúvidas e explicar o passo a passo sobre a nossa parceria. Sempre de forma humanizada e prática. Esse suporte é constante, ok?",
  },
  {
    n: "03",
    icon: "/images-capa2/comoFunciona/megafone.svg",
    iconTitle: "ícone divulgação",
    title: "Divulgue muito!",
    desc: "Após o treinamento com nosso time, é hora de divulgar as marcas, serviços e produtos parceiros com o seu link exclusivo de afiliado",
  },
  {
    n: "04",
    icon: "/images-capa2/comoFunciona/step-publique.svg",
    iconTitle: "ícone alvo",
    title: "Acompanhe seus resultados",
    desc: "Claro que para acompanhar suas vendas você terá acesso aos nossos relatórios personalizados para conferir, em tempo real, os acessos, comissão e outros dados importantes",
  },
  {
    n: "05",
    icon: "/images-capa2/comoFunciona/livro.svg",
    iconTitle: "ícone livros",
    title: "Aprenda muito",
    desc: "Quer escalar suas vendas? Conte com os conteúdos da Academia do Parceiros Promo para aprender as melhores estratégias do mercado para vendas de serviços e produtos do turismo",
  },
  {
    n: "06",
    icon: "/images-capa2/comoFunciona/dinheiro.svg",
    iconTitle: "ícone financeiro",
    title: "Receba comissão por toda venda!",
    desc: "Receba comissionamento de toda venda feita em seu link.",
  },
];

const ComoFuncionaV2: React.FC = () => {
  const gridRef = useRef<HTMLDivElement>(null);
  const [ativo, setAtivo] = useState(0);

  const strideDe = (el: HTMLDivElement) => {
    const card = el.children[0] as HTMLElement | undefined;
    return card ? card.offsetWidth + 16 : el.clientWidth;
  };

  const onScroll = () => {
    const el = gridRef.current;
    if (!el) return;
    const i = Math.round(el.scrollLeft / strideDe(el));
    setAtivo(Math.min(STEPS.length - 1, Math.max(0, i)));
  };

  const irPara = (i: number) => {
    const el = gridRef.current;
    if (!el) return;
    el.scrollTo({ left: i * strideDe(el), behavior: "smooth" });
  };

  return (
    <section id="como-funciona" className={styles.como}>
      <h2>Como o Parceiros Promo funciona na prática?</h2>

      <div className={styles.grid} ref={gridRef} onScroll={onScroll}>
        {STEPS.map((s) => (
          <div key={s.n} className={styles.card}>
            <div className={styles.cardTop}>
              <span className={styles.number}>{s.n}</span>
              <span className={styles.iconBox}>
                <img
                  src={s.icon}
                  alt={`passo ${s.n}`}
                  title={s.iconTitle ?? `passo ${s.n}`}
                />
              </span>
            </div>
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>

      <div className={styles.dots} role="tablist" aria-label="Passos">
        {STEPS.map((s, i) => (
          <button
            key={s.n}
            type="button"
            className={`${styles.dot} ${i === ativo ? styles.dotActive : ""}`}
            aria-label={`Passo ${s.n}`}
            aria-current={i === ativo}
            onClick={() => irPara(i)}
          />
        ))}
      </div>
    </section>
  );
};

export default ComoFuncionaV2;
